import React, { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { useDarkMode } from '../../context/DarkModeContext'

// The "⋯" menu at the end of a mailbox or template row.
const ActionsMenu = ({ label, actions }) => {
	const { isDarkMode } = useDarkMode()
	const isLight = !isDarkMode

	return (
		<Menu as="div" className="relative">
			<Menu.Button
				aria-label={label}
				className={`w-9 h-9 inline-flex items-center justify-center rounded-md text-lg leading-none ${
					isLight ? 'text-gray-500 hover:bg-gray-100' : 'text-gray-400 hover:bg-white/10'
				}`}
			>
				⋯
			</Menu.Button>
			<Transition
				as={Fragment}
				enter="transition ease-out duration-100"
				enterFrom="transform opacity-0 scale-95"
				enterTo="transform opacity-100 scale-100"
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95"
			>
				<Menu.Items
					className={`absolute right-0 z-20 mt-1 w-48 origin-top-right rounded-md py-1 shadow-lg ring-1 focus:outline-none ${
						isLight ? 'bg-white ring-gray-200' : 'bg-[#0D1117] ring-gray-800'
					}`}
				>
					{actions.map((action, index) => (
						<Menu.Item key={action.label}>
							{({ active }) => (
								<button
									type="button"
									onClick={action.onClick}
									className={`flex w-full px-4 py-2 text-sm ${
										action.danger && index > 0 ? `border-t ${isLight ? 'border-gray-100' : 'border-gray-800'}` : ''
									} ${
										action.danger
											? active ? (isLight ? 'bg-red-50 text-red-700' : 'bg-red-500/10 text-red-400') : (isLight ? 'text-red-600' : 'text-red-400')
											: active ? (isLight ? 'bg-gray-100 text-gray-900' : 'bg-gray-800 text-white') : (isLight ? 'text-gray-700' : 'text-gray-300')
									}`}
								>
									{action.label}
								</button>
							)}
						</Menu.Item>
					))}
				</Menu.Items>
			</Transition>
		</Menu>
	)
}

export default ActionsMenu
